<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'SharePoint verbinden'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col gap-4">
    @if (!sent) {
      <span class="text-sm text-gray-500">planBIC fordert in eurem Microsoft-365-Tenant folgende Berechtigungen an:</span>
      <div class="flex flex-col gap-3 p-4 rounded-lg bg-gray-50 border border-gray-200">
        <div class="flex flex-row gap-3">
          <fa-icon [icon]="faShieldHalved" class="text-green pt-0.5"></fa-icon>
          <div class="flex flex-col">
            <span class="text-sm font-semibold text-gray-900">Ausgewählte Sites lesen</span>
            <span class="text-sm text-gray-500">Zugriff nur auf SharePoint-Sites, die ihr ausdrücklich freigebt – nicht auf den ganzen Tenant.</span>
          </div>
        </div>
        <div class="flex flex-row gap-3">
          <fa-icon [icon]="faShieldHalved" class="text-green pt-0.5"></fa-icon>
          <div class="flex flex-col">
            <span class="text-sm font-semibold text-gray-900">Sites für planBIC freigeben</span>
            <span class="text-sm text-gray-500">Freigeben und Entfernen von Sites erledigt ein SharePoint-Admin, der Mitglied der Site ist. planBIC speichert diese Anmeldung nicht.</span>
          </div>
        </div>
      </div>

      <span class="text-sm font-semibold text-gray-900">Wer stimmt in Microsoft zu?</span>
      <label class="flex flex-row gap-3 p-3 rounded-lg border cursor-pointer"
             [class.border-green]="approver === 'self'" [class.border-gray-200]="approver !== 'self'">
        <input type="radio" name="approver" value="self" [(ngModel)]="approver" class="mt-1 text-green focus:ring-0">
        <div class="flex flex-col">
          <span class="text-sm text-gray-900">Ich bin Microsoft-365-Administrator*in</span>
          <span class="text-sm text-gray-500">Du wirst zu Microsoft weitergeleitet und stimmst direkt zu (Globaler Administrator oder Administrator für privilegierte Rollen).</span>
        </div>
      </label>
      <label class="flex flex-row gap-3 p-3 rounded-lg border cursor-pointer"
             [class.border-green]="approver === 'it'" [class.border-gray-200]="approver !== 'it'">
        <input type="radio" name="approver" value="it" [(ngModel)]="approver" class="mt-1 text-green focus:ring-0">
        <div class="flex flex-col flex-grow gap-2">
          <div class="flex flex-col">
            <span class="text-sm text-gray-900">Jemand anderes ist Administrator*in</span>
            <span class="text-sm text-gray-500">Wir senden der IT einen Zustimmungslink per E-Mail (7 Tage gültig).</span>
          </div>
          @if (approver === 'it') {
            <bic-input [label]="'E-Mail der IT'" [placeholder]="'it@firma.de'" [(ngModel)]="email" [showX]="false"></bic-input>
          }
        </div>
      </label>
    } @else {
      <span class="text-sm text-gray-900">Der Zustimmungslink wurde gesendet. Sobald die IT zugestimmt hat, ist SharePoint hier verbunden.</span>
      <div class="flex flex-row items-center gap-2 p-3 rounded-lg bg-gray-50 border border-gray-200">
        <span class="text-xs text-gray-500 truncate flex-grow">{{ sent.consentUrl }}</span>
        <bic-button buttonType="white" [iconOnly]="true" ariaLabel="Link kopieren" title="Link kopieren" (onClick)="copyLink()">
          <fa-icon [icon]="faCopy"></fa-icon>
        </bic-button>
      </div>
      @if (sent.consentUrlExpiresAt) {
        <span class="text-xs text-gray-500">Gültig bis {{ sent.consentUrlExpiresAt | date:'dd.MM.yyyy' }}. Ein neuer Link macht diesen ungültig.</span>
      }
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    @if (!sent) {
      <bic-button buttonType="white" (onClick)="close()">Abbrechen</bic-button>
      @if (approver === 'self') {
        <bic-button [loading]="busy" [disabled]="busy" (onClick)="continue()">Weiter zu Microsoft</bic-button>
      } @else {
        <bic-button [loading]="busy" [disabled]="busy || !email.trim()" (onClick)="continue()">
          <fa-icon [icon]="faPaperPlaneTop" class="pr-2"></fa-icon>Link senden
        </bic-button>
      }
    } @else {
      <bic-button (onClick)="close()">Fertig</bic-button>
    }
  </div>
</bic-popup>
